module.exports = __webpack_public_path__ + "static/media/radio-2.7ef5b0af.svg";